const typographyFormService = {
  true: 'New Service',
  false: 'Service Details',
  signature: 'SIGNATURE',
  signatures: 'SIGNATURES',
  signatureLabel: 'Signature',
  attachFiles: 'ATTACH FILES',
  addSignature: 'Add Signature',
  addSignatures: 'Add signatures to the service',
  mandatorySignature: 'Signature is mandatory for this service',
  complement: 'Complement',
}

export default typographyFormService;
